
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

export function useStripeCheckout() {
  const [loading, setLoading] = useState(false);

  /**
   * Kick off checkout for a given tier.
   * @param tierId    one of "solo" | "small" | "medium"
   * @param emailOpt  supply for guests; omitted for logged‑in users
   */
  const startCheckout = async (
    tierId: "solo" | "small" | "medium",
    emailOpt?: string
  ) => {
    try {
      setLoading(true);
      toast({ title: "Preparing checkout…" });

      const body: Record<string, unknown> = { tierId };
      if (emailOpt) body.email = emailOpt;

      const { data, error } = await supabase.functions.invoke(
        "create-checkout",
        { body }
      );

      if (error) throw error;
      if (!data?.url) throw new Error("No Stripe URL returned");

      window.location.href = data.url as string;
    } catch (err: any) {
      toast({
        title: "Checkout error",
        description: err.message || "Please try again later",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  return { startCheckout, loading };
}
